import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useMemo, useState } from "react";
const HeaderContext = createContext(undefined);
const HeaderProvider = ({ children }) => {
    const [hoveredIndex, setHoveredIndex] = useState(null);
    const [loyaltyData, setLoyaltyData] = useState({ points: null, userTier: null, isActive: false });
    const onClick = () => {
        setHoveredIndex(null);
    };
    const contextValues = useMemo(() => ({
        hoveredIndex,
        setHoveredIndex,
        isLoyaltyActive: loyaltyData.isActive,
        userTier: loyaltyData.userTier,
        loyaltyPoints: loyaltyData.points,
        setLoyaltyData,
        onClick,
    }), [hoveredIndex, loyaltyData.isActive, loyaltyData.points, loyaltyData.userTier]);
    return _jsx(HeaderContext.Provider, { value: contextValues, children: children });
};
const useHeaderContext = () => {
    const context = useContext(HeaderContext);
    if (context === undefined) {
        throw new Error("headerContext must be used within a HeaderProvider");
    }
    return context;
};
export { HeaderProvider, useHeaderContext };
//# sourceMappingURL=context.js.map